import { parse } from 'exifr/dist/lite.esm.mjs';

type ExifrTags = Record<string, unknown>;

const pickCreditFromTags = (tags: ExifrTags): string | undefined => {
  const creditValue =
    tags.Credit ??
    tags.Copyright ??
    tags.Rights ??
    tags.UsageTerms ??
    tags.Artist ??
    tags['dc:rights'];

  if (typeof creditValue === 'string') {
    const trimmed = creditValue.trim();
    return trimmed.length > 0 ? trimmed : undefined;
  }

  if (
    typeof creditValue === 'object' &&
    creditValue !== null &&
    'value' in creditValue
  ) {
    const trimmed = String((creditValue as { value: string }).value).trim();
    return trimmed.length > 0 ? trimmed : undefined;
  }

  return undefined;
};

export const extractImageCreditFromFile = async (
  file: File,
): Promise<string | undefined> => {
  try {
    const tags = await parse(file, {
      xmp: { parse: true },
      tiff: true,
    });

    if (!tags || typeof tags !== 'object') {
      return undefined;
    }

    return pickCreditFromTags(tags as ExifrTags);
  } catch {
    return undefined;
  }
};
